var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgXml = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.583 0H2.41699C1.31699 0 0.416992 0.9 0.416992 2V6.689H6.74099V8.689H0.416992V11.39H9.36799V13.39H0.416992V30C0.416992 31.1 1.31699 32 2.41699 32H23.582C24.682 32 25.582 31.1 25.582 30V2C25.583 0.9 24.682 0 23.583 0V0Z",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86084 22.8076L8.06055 20.6016H9.57666L7.71338 23.7744L9.625 27H8.09131L6.86084 24.7588L5.63037 27H4.09668L6.0083 23.7744L4.14502 20.6016H5.66113L6.86084 22.8076ZM12.0156 20.6016L13.6592 25.2422L15.2939 20.6016H17.0254V27H15.7026V25.251L15.8345 22.2319L14.1074 27H13.2021L11.4795 22.2363L11.6113 25.251V27H10.293V20.6016H12.0156ZM19.4951 25.9409H22.2944V27H18.1768V20.6016H19.4951V25.9409Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXml, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xml.ebda8bbb.svg";
export { ForwardRef as ReactComponent };